import { render, staticRenderFns } from "./ProfileDropDown.vue?vue&type=template&id=27103fa3&scoped=true"
import script from "./ProfileDropDown.vue?vue&type=script&lang=js"
export * from "./ProfileDropDown.vue?vue&type=script&lang=js"
import style0 from "./ProfileDropDown.vue?vue&type=style&index=0&id=27103fa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27103fa3",
  null
  
)

export default component.exports